import React from 'react';

export default function Loading() {
  return (
    // TODO - Make it prettier dude! It's yours...
    <div>
      <h1>LOADING...</h1>
    </div>
  );
}
